import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchCustomerPaymentList = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        axios.post('/customerPayment/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.status) {
                commit('setCustomerPaymentList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
                if(payload.fetch_sale_order) {
                    dispatch('fetchSaleMasterDataBalance', {id: payload.sale_id})
                }
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error-1'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchCustomerPaymentData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/customerPayment/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('setCustomerPaymentData', {response: res.data.response, copy: payload.copy})   
            commit('setCustomerMasterAutocompleteList', [{
                id: res.data.response.customer_id,
                type_of_customer: res.data.response.type_of_customer,
                salutation_name: res.data.response.salutation_name,
                customer_name: res.data.response.customer_name,
                company_name:res.data.response.company_name
            }])
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetCustomerPaymentData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitCustomerPaymentData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/customerPayment/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            if(payload.redeemed_amount>0) {
                dispatch('fetchSaleMasterList', {
                    customer_id: payload.customer_id,
                    show_outstanding: true,
                    store_list: payload.store_list
                })                
            }
            commit('resetCustomerPaymentFormpartial')
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteCustomerPaymentData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/customerPayment/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
                
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else if(payload.popup) {
            } else {
                if(payload.sale_id>0) {
                    payload.list.sale_id = payload.sale_id
                }
                dispatch('fetchCustomerPaymentList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-2'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/customerPayment/actions.js